import { useNavigate } from "react-router-dom";
import {
    Box,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import AddRatingReply from "../../Modals/addReplyRating";
import StarIcon from "@mui/icons-material/Star";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VerifiedIcon from "@mui/icons-material/Verified";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const Ratings = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const rows = [
        {
            id: "REV001",
            name: "Nader Qasim",
            email: "nader.qasim@gmail.com",
            phone: "+971 50 123 4567",
            verified: true,
            date: "12/12/2025",
            orderId: "ORD-2025-1123",
            productId: "PRD-88921",
            productName: "Premium Leather Backpack",
            rating: 5,
            title: "Exceeded expectations",
            review:
                "Absolutely love this product! The quality is exceptional and delivery was super fast. Highly recommend to anyone looking for premium items.",
            status: "approved",
        },
        {
            id: "REV002",
            name: "Mohammed Khan",
            email: "mohammed.khan@example.com",
            phone: "+971 55 987 2341",
            verified: true,
            date: "12/12/2025",
            orderId: "ORD-2025-1140",
            productId: "PRD-77210",
            productName: "Wireless Noise Cancelling Headphones",
            rating: 4,
            title: "Very good quality",
            review:
                "Exceeded my expectations. The packaging was beautiful and the product itself is even better in person. Will definitely order again.",
            status: "approved",
        },
        {
            id: "REV003",
            name: "Sara Ahmed",
            email: "sara.ahmed@example.com",
            phone: "+971 52 456 8899",
            verified: false,
            date: "11/12/2025",
            orderId: "ORD-2025-1189",
            productId: "PRD-66543",
            productName: "Smart Fitness Watch",
            rating: 3,
            title: "Good but needs improvement",
            review:
                "The watch is good for basic tracking, but battery life could be better. UI feels a bit laggy sometimes.",
            status: "pending",
        },
        {
            id: "REV004",
            name: "Amit Verma",
            email: "amit.verma@example.com",
            phone: "+91 98765 43210",
            verified: true,
            date: "10/12/2025",
            orderId: "ORD-2025-1199",
            productId: "PRD-55221",
            productName: "Ergonomic Office Chair",
            rating: 2,
            title: "Not satisfied",
            review:
                "The chair looks good but comfort is not as expected. Back support is weak and assembly instructions were unclear.",
            status: "approved",
        },
    ];

    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const ratingDistribution = [
        { stars: 5, count: 16 },
        { stars: 4, count: 21 },
        { stars: 3, count: 10 },
        { stars: 2, count: 3 },
        { stars: 1, count: 0 },
    ];

    const maxCount = Math.max(...ratingDistribution.map(r => r.count));

    return (
        <>
            <div className="main_title">
                <h1>Manage Customer Ratings & Reviews</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -Customer Ratings & Reviews
                </p>
            </div>
            <div className="stats_boxes gap_m">
                {/* TOTAL REVIEWS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            50
                            <p>Total Reviews</p>
                        </h2>
                        <figure className="warning">
                            <StarIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* AVERAGE RATING */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            4.0
                            <p>Average Rating</p>
                        </h2>
                        <figure className="sucess">
                            <TrendingUpIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* VERIFIED PURCHASES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            32
                            <p>Verified Purchases</p>
                        </h2>
                        <figure className="blue">
                            <VerifiedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* PENDING REVIEWS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            4
                            <p>Pending Review</p>
                        </h2>
                        <figure className="danger">
                            <ErrorOutlineIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>
            <div className="cards rating_distribution mt_20">
                <h4 className="card_title">Rating Distribution</h4>

                <div className="rating_dist_list">
                    {ratingDistribution.map((item) => (
                        <div className="rating_row" key={item.stars}>
                            {/* Stars */}
                            <div className="stars">
                                {item.stars} <span>★</span>
                            </div>

                            {/* Progress bar */}
                            <div className="bar">
                                <span
                                    className="fill"
                                    style={{
                                        width: `${(item.count / maxCount) * 100}%`,
                                    }}
                                />
                            </div>

                            {/* Count */}
                            <div className="count">{item.count}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="reviews_wrapper mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search product..."
                            />
                        </Box>
                        <div className="form">
                            <select>
                                <option value="all">All Ratings</option>
                                <option value="footwear">5 Star</option>
                                <option value="clothing">4 Star</option>
                                <option value="accessories">3 Star</option>
                                <option value="accessories">2 Star</option>
                                <option value="accessories">1 Star</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="reviews_list">

                    {rows.map((row) => (
                        <div className="review_card" key={row.id} onClick={() => navigate("/manage-products/view")}>
                            {/* LEFT – User */}
                            <div className="review_user">
                                <figure className="avatar">
                                    {row.name.charAt(0)}
                                </figure>

                                <div className="user_info">
                                    <h4>
                                        {row.name}
                                        {row.verified && (
                                            <span className="verified_badge">✔ Verified</span>
                                        )}
                                    </h4>
                                    <p>{row.email}</p>
                                    <small>{row.date}</small>
                                </div>
                            </div>

                            {/* CENTER – Review + Product */}
                            <div className="review_content">
                                {/* Product Info */}
                                <div className="product_info">
                                    <span className="pid">#{row.productId}</span>
                                    <span className="pname">{row.productName}</span>
                                </div>

                                {/* Rating */}
                                <div className="rating">
                                    {"⭐".repeat(row.rating)}
                                    {row.rating < 5 && "☆".repeat(5 - row.rating)}
                                </div>

                                <h5>{row.title}</h5>
                                <p>{row.review}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


            <AddRatingReply
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default Ratings;
